import { I18nServiceImpl } from "./service"

export function setupI18n(module: ng.IModule) {

    module.service("OmniaI18n", I18nServiceImpl)

}
